const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const moment = require('moment');
const { DATE_FORMAT_API, DATE_FILTER_NONE } = require('constants/index');

const requestMovementsFetching = valueId => ({
    type: actionTypes.BROKER_VALUE_MOVEMENTS_REQUEST,
    payload: {
        valueId
    }
});

const requestMovementsFailure = (error, valueId) => ({
    type: actionTypes.BROKER_VALUE_MOVEMENTS_FAILURE,
    payload: {
        error,
        valueId
    }
});

const requestMovementsSuccess = (data, valueId) => ({
    type: actionTypes.BROKER_VALUE_MOVEMENTS_SUCCESS,
    payload: {
        data,
        valueId
    }
});

const requestGetMoreMovementsFetching = valueId => ({
    type: actionTypes.BROKER_VALUE_MOVEMENTS_GET_MORE_MOVEMENTS_REQUEST,
    payload: {
        valueId
    }
})

const requestGetMoreMovementsFailure = (error, valueId) => ({
    type: actionTypes.BROKER_VALUE_MOVEMENTS_GET_MORE_MOVEMENTS_FAILURE,
    payload: {
        error,
        valueId
    }
})

const requestGetMoreMovementsSuccess = (data, valueId) => ({
    type: actionTypes.BROKER_VALUE_MOVEMENTS_GET_MORE_MOVEMENTS_SUCCESS,
    payload: {
        data,
        valueId
    }
})

const setFilter = (filter, valueId) => ({
    type: actionTypes.BROKER_VALUE_MOVEMENTS_SET_FILTER,
    payload: {
        filter,
        valueId
    }
});

const clearFilter = valueId => ({
    type: actionTypes.BROKER_VALUE_MOVEMENTS_CLEAR_FILTER,
    payload: {
        valueId
    }
});

const getValueMovements = (immContract, immValue) => (dispatch, getState) => {
    const valueId = immValue.get('id');
    const requestData = {
        query: {
            codigoEmision: immValue.get('emisionCode'),
            codigoValor: immValue.get('valueCode'),
            producto: immContract.get('productNumber'),
            numeroContrato: immContract.get('walletNumber'),
            paginate: true,
        }
    };
    const immFilters = getState().brokerValueMovements.getIn([valueId, 'filters']);

    // @hardcoded
    requestData.query.fechaDesde = moment().startOf('day')/*.subtract(2, 'year')*/.year(2010).format(DATE_FORMAT_API);
    requestData.query.fechaHasta = moment().startOf('day').format(DATE_FORMAT_API);

    if (immFilters && immFilters.getIn(['date', 'isActive']) && immFilters.getIn(['date', 'selected']) !== DATE_FILTER_NONE) {
        // @hardcoded
        requestData.query.fechaDesde = moment(immFilters.getIn(['date', 'from'])).format(DATE_FORMAT_API);
        requestData.query.fechaHasta = moment(immFilters.getIn(['date', 'to'])).format(DATE_FORMAT_API);
    }

    dispatch(requestMovementsFetching(valueId));
    return APIGet(dispatch, apiURLBuilder.getURL('getValueMovements'), requestData)
        .then(response => dispatch(requestMovementsSuccess(response, valueId)))
        .catch(error => dispatch(requestMovementsFailure(error, valueId)));
};

const getNextMovementPage = (immValue) => (dispatch, getState) => {
    const valueId = immValue.get('id');
    const url = getState().brokerValueMovements.getIn([valueId, 'nextLink']);
    dispatch(requestGetMoreMovementsFetching(valueId))
    return APIGet(dispatch, url)
        .then(response => dispatch(requestGetMoreMovementsSuccess(response, valueId)))
        .catch(error => dispatch(requestGetMoreMovementsFailure(error, valueId)));
}

module.exports = {
    getValueMovements,
    getNextMovementPage,
    setFilter,
    clearFilter
};
